{
 "traits": {
  "focus": {
   "kw": "уважне слухання на уроках",
   "lines": [
    "{○○ уважно слухає на уроках і стежить за кожним поясненням|Ти уважно слухаєш на уроках і стежиш за кожним поясненням}.",
    "{○○ зосереджено працює на уроках і не відволікається від завдання|Ти зосереджено працюєш на уроках і не відволікаєшся від завдання}.",
    "На уроках {○○ дивиться на того, хто говорить, і засвоює інструкції з першого разу|ти дивишся на того, хто говорить, і засвоюєш інструкції з першого разу}.",
    "{○○ вміє зосереджуватися, тому швидко засвоює новий матеріал|Ти вмієш зосереджуватися, тому швидко засвоюєш новий матеріал}.",
    "Навіть коли в класі гамірно, {○○ не відволікається від завдання|ти не відволікаєшся від завдання}.",
    "{○○ уважно слухає інструкції та одразу береться до роботи|Ти уважно слухаєш інструкції та одразу берешся до роботи}."
   ]
  },
  "effort": {
   "kw": "наполеглива праця",
   "lines": [
    "{○○ вкладає справжні зусилля в кожне завдання і пишається якісно виконаною роботою|Ти вкладаєш справжні зусилля в кожне завдання і пишаєшся якісно виконаною роботою}.",
    "{○○ демонструє|Ти демонструєш} працьовитість упродовж усього семестру.",
    "{○○ докладає|Ти докладаєш} максимум зусиль до кожного завдання, легке воно чи складне.",
    "{○○ вирізняється працьовитістю — це одна з найсильніших сторін|Працьовитість — одна з твоїх найсильніших сторін}.",
    "{○○ не шкодує часу, щоб виконати роботу добре|Ти не шкодуєш часу, щоб виконати роботу добре}.",
    "Видно, що {○○ серйозно ставиться до навчання і завжди прагне показати найкращий результат|ти серйозно ставишся до навчання і завжди прагнеш найкращого результату}."
   ]
  },
  "homework": {
   "kw": "охайні, повні домашні завдання",
   "lines": [
    "{○○ послідовно здає|Ти послідовно здаєш} домашні завдання — повні, охайні й вчасно.",
    "{○○ виконує завдання з турботою та увагою до деталей|Ти виконуєш завдання з турботою та увагою до деталей}.",
    "Домашні завдання здаються вчасно та свідчать про справжню дбайливість.",
    "{○○ ретельно виконує завдання та охайно їх оформлює|Ти ретельно виконуєш завдання та охайно їх оформлюєш}.",
    "{○○ серйозно ставиться до домашніх завдань, і це видно за якістю роботи|Ти серйозно ставишся до домашніх завдань, і це видно за якістю роботи}.",
    "{○○ стабільно виконує домашні завдання охайно, повно й продумано|Ти стабільно виконуєш домашні завдання охайно, повно й продумано}."
   ]
  },
  "speak": {
   "kw": "впевнена участь",
   "lines": [
    "{○○ активно бере участь в обговореннях і впевнено ділиться ідеями|Ти активно береш участь в обговореннях і впевнено ділишся ідеями}.",
    "{○○ завжди охоче піднімає руку та долучається до обговорення в класі|Ти завжди охоче піднімаєш руку та долучаєшся до обговорення в класі}.",
    "{○○ охоче ділиться ідеями та збагачує розмови в класі|Ти охоче ділишся ідеями та збагачуєш розмови в класі}.",
    "{○○ робить обговорення в класі змістовнішими завдяки продуманим реплікам|Ти робиш обговорення в класі змістовнішими завдяки своїм продуманим реплікам}.",
    "{○○ впевнено висловлюється та розвиває ідеї інших|Ти впевнено висловлюєшся та розвиваєш ідеї інших}.",
    "Коли звучить запитання, {○○ часто відповідає одним із перших|ти часто відповідаєш одним із перших}."
   ]
  },
  "curious": {
   "kw": "природна цікавість",
   "lines": [
    "{○○ підходить до навчання з природною цікавістю та часто ставить продумані запитання|Ти підходиш до навчання з природною цікавістю та часто ставиш продумані запитання}.",
    "{○○ прагне досліджувати нові ідеї та розуміти, як усе влаштовано|Ти прагнеш досліджувати нові ідеї та розуміти, як усе влаштовано}.",
    "{○○ ставить чудові запитання, що допомагають усьому класу замислитися глибше|Ти ставиш чудові запитання, що допомагають усьому класу замислитися глибше}.",
    "{○○ любить дізнаватися, чому щось відбувається і як воно працює|Ти любиш дізнаватися, чому щось відбувається і як воно працює}.",
    "Нові теми викликають інтерес, і {○○ завжди прагне дізнатися більше|ти завжди прагнеш дізнатися більше}.",
    "{○○ ставить запитання, які свідчать про глибокі роздуми та прагнення зрозуміти|Ти ставиш запитання, які свідчать про глибокі роздуми та прагнення зрозуміти}."
   ]
  },
  "reading": {
   "kw": "любов до читання",
   "lines": [
    "{○○ щиро любить читати, а книжка в руках — звична картина|Ти щиро любиш читати, а книжка в твоїх руках — звична картина}.",
    "{Завдяки звичці до читання ○○ має багатий словниковий запас і широкі знання|Завдяки звичці до читання ти маєш багатий словниковий запас і широкі знання}.",
    "{○○ багато й різноманітно читає та із задоволенням розповідає про улюблені книжки|Ти багато й різноманітно читаєш та із задоволенням розповідаєш про улюблені книжки}.",
    "{○○ з особливим задоволенням проводить час за читанням|Ти з особливим задоволенням проводиш час за читанням}.",
    "{○○ охоче обирає книжки та читає дедалі вільніше й з глибшим розумінням|Ти охоче обираєш книжки та читаєш дедалі вільніше й з глибшим розумінням}.",
    "{○○ виявляє любов до книжок у мовленні та письмових роботах|Ти виявляєш любов до книжок у своєму мовленні та письмових роботах}."
   ]
  },
  "careful": {
   "kw": "ретельна, точна робота",
   "lines": [
    "{○○ працює ретельно й перевіряє точність перед здачею роботи|Ти працюєш ретельно й перевіряєш точність перед здачею роботи}.",
    "{○○ звертає пильну увагу на деталі в кожному завданні|Ти звертаєш пильну увагу на деталі в кожному завданні}.",
    "{○○ знаходить час довести деталі до ладу і рідко поспішає в роботі|Ти знаходиш час довести деталі до ладу і рідко поспішаєш у роботі}.",
    "{○○ виконує роботи точно, ґрунтовно й охайно їх оформлює|Ти виконуєш роботи точно, ґрунтовно й охайно їх оформлюєш}.",
    "{○○ уважно перевіряє відповіді та виправляє дрібні помилки перед здачею роботи|Ти уважно перевіряєш відповіді та виправляєш дрібні помилки перед здачею роботи}.",
    "{○○ виявляє увагу до деталей, і це справжня сильна сторона в щоденній роботі|Увага до деталей — твоя справжня сильна сторона в щоденній роботі}."
   ]
  },
  "selfdriven": {
   "kw": "самостійність та ініціатива",
   "lines": [
    "{○○ виявляє ініціативу в навчанні та виконує завдання без нагадувань|Ти виявляєш ініціативу в навчанні та виконуєш завдання без нагадувань}.",
    "{○○ має внутрішню мотивацію до навчання та шукає способи вдосконалюватися|Ти маєш внутрішню мотивацію до навчання та шукаєш способи вдосконалюватися}.",
    "{○○ одразу береться до завдань і добре працює самостійно|Ти одразу берешся до завдань і добре працюєш самостійно}.",
    "{○○ ставить особисті цілі та наполегливо йде до них|Ти ставиш особисті цілі та наполегливо йдеш до них}.",
    "Без жодних прохань {○○ часто шукає можливості дізнатися більше|ти часто шукаєш можливості дізнатися більше}.",
    "{○○ має сильну мотивацію до навчання й майже не потребує нагадувань|Ти маєш сильну мотивацію до навчання й майже не потребуєш нагадувань}."
   ]
  },
  "persist": {
   "kw": "наполегливість",
   "lines": [
    "{○○ виявляє велику наполегливість і не припиняє спроб, коли завдання складне|Ти виявляєш велику наполегливість і не припиняєш спроб, коли завдання складне}.",
    "{○○ не здається легко та наполегливо долає труднощі|Ти не здаєшся легко та наполегливо долаєш труднощі}.",
    "{○○ не зупиняється, коли робота ускладнюється, і доводить справу до кінця|Ти не зупиняєшся, коли робота ускладнюється, і доводиш справу до кінця}.",
    "Труднощі не лякають, і {○○ пробує ще раз, обравши інший підхід|ти пробуєш ще раз, обравши інший підхід}.",
    "{○○ виявляє рішучість щоразу, коли завдання потребує додаткових зусиль|Ти виявляєш рішучість щоразу, коли завдання потребує додаткових зусиль}.",
    "{○○ розуміє, що помилки — частина навчання, і не припиняє спроб|Ти розумієш, що помилки — частина навчання, і не припиняєш спроб}."
   ]
  },
  "kind": {
   "kw": "доброта",
   "lines": [
    "{○○ виявляє доброту та співчуття до інших|Ти виявляєш доброту та співчуття до інших}.",
    "{○○ дбайливо й уважно ставиться до інших, і однокласникам поруч комфортно|Ти дбайливо й уважно ставишся до інших, і однокласникам поруч з тобою комфортно}.",
    "{○○ помічає, коли іншим потрібна розрада, і відповідає теплом|Ти помічаєш, коли іншим потрібна розрада, і відповідаєш теплом}.",
    "{○○ турботливо ставиться до інших, тому однокласники відчувають себе цінними та в безпеці|Ти турботливо ставишся до інших, тому однокласники відчувають себе цінними та в безпеці}.",
    "{○○ щодня робить дрібні добрі вчинки, і це виходить природно|Ти щодня робиш дрібні добрі вчинки, і це виходить природно}.",
    "{○○ ставиться до інших лагідно та думає про їхні почуття|Ти ставишся до інших лагідно та думаєш про їхні почуття}."
   ]
  },
  "honest": {
   "kw": "чесність",
   "lines": [
    "{○○ завжди чесно поводиться та бере на себе відповідальність за помилки|Ти завжди чесно поводишся та береш на себе відповідальність за помилки}.",
    "{○○ заслуговує на довіру вчителів і однокласників завдяки чесності|Ти заслуговуєш на довіру вчителів і однокласників завдяки чесності}.",
    "{○○ говорить правду, навіть коли це нелегко|Ти говориш правду, навіть коли це нелегко}.",
    "{Завдяки чесності ○○ — людина, якій можна довіряти|Завдяки чесності ти — людина, якій можна довіряти}.",
    "{○○ визнає свої помилки й учиться на них|Ти визнаєш свої помилки й учишся на них}.",
    "Учителі та однокласники знають, що {○○ завжди дотримується слова|ти завжди дотримуєшся слова}."
   ]
  },
  "polite": {
   "kw": "гарні манери",
   "lines": [
    "{○○ ввічливо й шанобливо ставиться до вчителів та однокласників|Ти ввічливо й шанобливо ставишся до вчителів та однокласників}.",
    "{○○ вирізняється гарними манерами та чемністю, які помічають усі в школі|Ти вирізняєшся гарними манерами та чемністю, які помічають усі в школі}.",
    "{○○ без нагадувань користується добрими словами на кшталт «будь ласка» і «дякую»|Ти без нагадувань користуєшся добрими словами на кшталт «будь ласка» і «дякую»}.",
    "{○○ має чемну манеру поведінки, яка справляє позитивне враження на всіх|Ти маєш чемну манеру поведінки, яка справляє позитивне враження на всіх}.",
    "{○○ тепло вітається з дорослими й однокласниками та говорить шанобливо|Ти тепло вітаєшся з дорослими й однокласниками та говориш шанобливо}.",
    "{○○ природно виявляє гарні манери — і в класі, і в школі загалом|Ти природно виявляєш гарні манери — і в класі, і в школі загалом}."
   ]
  },
  "responsible": {
   "kw": "високе почуття відповідальності",
   "lines": [
    "{○○ завжди доводить завдання до кінця, на це можна покластися|Ти завжди доводиш завдання до кінця, на тебе можна покластися}.",
    "{○○ серйозно ставиться до обов'язків і є надійним членом класу|Ти серйозно ставишся до обов'язків і є надійним членом класу}.",
    "{○○ виконує взяті зобов'язання, тож можна довіряти важливі доручення|Ти виконуєш взяті зобов'язання, тож тобі можна довірити важливі доручення}.",
    "{○○ вирізняється надійністю, на яку покладаються вчителі та однокласники|Ти вирізняєшся надійністю, на яку покладаються вчителі та однокласники}.",
    "Отримавши завдання, {○○ ретельно доводить його до кінця|ти ретельно доводиш його до кінця}.",
    "{○○ відповідально ставиться до дорученого та до власних речей|Ти відповідально ставишся до дорученого та до власних речей}."
   ]
  },
  "positive": {
   "kw": "позитивний настрій",
   "lines": [
    "{○○ щодня приносить до класу життєрадісний, позитивний настрій|Ти щодня приносиш до класу життєрадісний, позитивний настрій}.",
    "{○○ освітлює клас оптимізмом і добрим гумором|Ти освітлюєш клас своїм оптимізмом і добрим гумором}.",
    "{○○ зустрічає кожен день з усмішкою та бадьорим настроєм|Ти зустрічаєш кожен день з усмішкою та бадьорим настроєм}.",
    "{○○ заражає ентузіазмом і піднімає настрій у класі|Ти заражаєш ентузіазмом і піднімаєш настрій у класі}.",
    "Навіть коли справи складні, {○○ зберігає бадьорість і надію|ти зберігаєш бадьорість і надію}.",
    "{○○ дарує|Ти даруєш} нашому класу тепло й гарний гумор."
   ]
  },
  "confident": {
   "kw": "впевненість у собі",
   "lines": [
    "{○○ впевнено береться за нові виклики|Ти впевнено берешся за нові виклики}.",
    "{○○ охоче пробує нове і не боїться помилятися|Ти охоче пробуєш нове і не боїшся помилятися}.",
    "{○○ береться за незнайомі завдання з настроєм «я зможу»|Ти берешся за незнайомі завдання з настроєм «я зможу»}.",
    "{○○ виявляє впевненість, коли показує роботу чи пробує щось нове|Ти виявляєш впевненість, коли показуєш роботу чи пробуєш щось нове}.",
    "{○○ із задоволенням береться за складні завдання і не ухиляється від важких запитань|Ти із задоволенням берешся за складні завдання і не ухиляєшся від важких запитань}.",
    "{○○ спокійно й упевнено ставиться до незнайомих ситуацій, вірячи у власні сили|Ти спокійно й упевнено ставишся до незнайомих ситуацій, вірячи у власні сили}."
   ]
  },
  "helpful": {
   "kw": "готовність допомагати",
   "lines": [
    "{○○ завжди охоче допомагає однокласникам, яким потрібна підтримка|Ти завжди охоче допомагаєш однокласникам, яким потрібна підтримка}.",
    "{○○ часто простягає руку допомоги та терпляче пояснює іншим|Ти часто простягаєш руку допомоги та терпляче пояснюєш іншим}.",
    "{○○ помічає, коли хтось застряг, і одразу пропонує підтримку|Ти помічаєш, коли хтось застряг, і одразу пропонуєш підтримку}.",
    "{○○ охоче допомагає, і це справді важливо для однокласників|Ти охоче допомагаєш, і це справді важливо для однокласників}.",
    "Однокласники часто звертаються по допомогу, і {○○ завжди охоче її надає|ти завжди охоче її надаєш}.",
    "{○○ допомагає іншим без прохань і завжди з усмішкою|Ти допомагаєш іншим без прохань і завжди з усмішкою}."
   ]
  },
  "teamwork": {
   "kw": "командна робота",
   "lines": [
    "{○○ добре працює в групах: слухає інших і справедливо ділить роботу|Ти добре працюєш у групах: слухаєш інших і справедливо ділиш роботу}.",
    "{○○ охоче співпрацює в команді та допомагає групі досягти успіху|Ти охоче співпрацюєш у команді та допомагаєш групі досягти успіху}.",
    "{○○ вносить ідеї в групову роботу та цінить внесок інших|Ти вносиш ідеї в групову роботу та цінуєш внесок інших}.",
    "У групових проєктах {○○ справедливо розподіляє завдання та підбадьорює товаришів по команді|ти справедливо розподіляєш завдання та підбадьорюєш товаришів по команді}.",
    "{○○ допомагає групам працювати злагоджено завдяки духу співпраці|Ти допомагаєш групам працювати злагоджено завдяки духу співпраці}.",
    "{○○ вміє іти на компроміс, щоб уся команда досягла успіху|Ти вмієш іти на компроміс, щоб уся команда досягла успіху}."
   ]
  },
  "friendly": {
   "kw": "товариськість",
   "lines": [
    "{○○ добре ладнає з однокласниками та дружить з багатьма|Ти добре ладнаєш з однокласниками та дружиш з багатьма}.",
    "{○○ доброзичливо ставиться до всіх і вміє зробити так, щоб іншим було затишно|Ти доброзичливо ставишся до всіх і вмієш зробити так, щоб іншим було затишно}.",
    "{○○ легко заводить друзів і залучає інших до ігор та занять|Ти легко заводиш друзів і залучаєш інших до ігор та занять}.",
    "{○○ має теплу, привітну манеру, яка допомагає однокласникам відчути себе бажаними|Ти маєш теплу, привітну манеру, яка допомагає однокласникам відчути себе бажаними}.",
    "{○○ легко знаходить спільну мову з усіма та добре ставиться до кожного|Ти легко знаходиш спільну мову з усіма та добре ставишся до кожного}.",
    "{○○ — приємна компанія для однокласників і на уроках, і в іграх|Ти — приємна компанія для однокласників і на уроках, і в іграх}."
   ]
  },
  "leader": {
   "kw": "лідерство",
   "lines": [
    "{○○ виявляє сильні лідерські якості та ефективно спрямовує групову роботу|Ти виявляєш сильні лідерські якості та ефективно спрямовуєш групову роботу}.",
    "{○○ має природні лідерські здібності та користується повагою однокласників|Ти маєш природні лідерські здібності та користуєшся повагою однокласників}.",
    "{○○ бере на себе провід у групових завданнях, але не забуває слухати інших|Ти береш на себе провід у групових завданнях, але не забуваєш слухати інших}.",
    "{○○ пропонує ідеї, які однокласники поважають і охоче підтримують|Ти пропонуєш ідеї, які однокласники поважають і охоче підтримують}.",
    "{○○ добре організовує групову роботу та стежить, щоб у кожного була своя роль|Ти добре організовуєш групову роботу та стежиш, щоб у кожного була своя роль}.",
    "{○○ веде за собою спокійно, справедливо й підбадьорливо|Ти ведеш за собою спокійно, справедливо й підбадьорливо}."
   ]
  },
  "respect": {
   "kw": "повага до інших",
   "lines": [
    "{○○ шанобливо слухає інших і цінує різні погляди|Ти шанобливо слухаєш інших і цінуєш різні погляди}.",
    "{○○ ставиться до всіх з повагою|Ти ставишся до всіх з повагою}.",
    "{○○ чекає своєї черги говорити та уважно слухає однокласників|Ти чекаєш своєї черги говорити та уважно слухаєш однокласників}.",
    "{○○ своєю шанобливою позицією допомагає створити позитивну атмосферу в класі|Ти своєю шанобливою позицією допомагаєш створити позитивну атмосферу в класі}.",
    "{○○ приймає відмінності та розмовляє з усіма чемно|Ти приймаєш відмінності та розмовляєш з усіма чемно}.",
    "Повага до інших видно з того, як {○○ слухає й відповідає|ти слухаєш і відповідаєш}."
   ]
  },
  "share": {
   "kw": "щедрість",
   "lines": [
    "{○○ щедро ділиться ідеями та матеріалами з однокласниками|Ти щедро ділишся ідеями та матеріалами з однокласниками}.",
    "{○○ із задоволенням ділиться з іншими тим, що дізнається|Ти із задоволенням ділишся з іншими тим, що дізнаєшся}.",
    "{○○ охоче ділиться приладдям і без метушні чекає своєї черги|Ти охоче ділишся приладдям і без метушні чекаєш своєї черги}.",
    "{○○ має щедру душу, і це цінують усі в класі|Ти маєш щедру душу, і це цінують усі в класі}.",
    "{○○ швидко ділиться ідеями та ресурсами під час групової роботи|Ти швидко ділишся ідеями та ресурсами під час групової роботи}.",
    "{○○ ділиться природно — чи то матеріалами, чи ідеями, чи часом|Ти ділишся природно — чи то матеріалами, чи ідеями, чи часом}."
   ]
  },
  "tidy": {
   "kw": "організованість",
   "lines": [
    "{○○ тримає парту в охайності, а навчальні матеріали впорядкованими|Ти тримаєш парту в охайності, а навчальні матеріали впорядкованими}.",
    "{○○ добре організовує себе й завжди має все потрібне до уроків|Ти добре організовуєш себе й завжди маєш усе потрібне до уроків}.",
    "{○○ завжди підтримує порядок на робочому місці, а речі легко знайти|Ти завжди підтримуєш порядок на робочому місці, а речі легко знайти}.",
    "{○○ тримає книжки й приладдя в порядку та дбає про них|Ти тримаєш книжки й приладдя в порядку та дбаєш про них}.",
    "Після занять {○○ швидко прибирає та залишає місце чистим|ти швидко прибираєш і залишаєш місце чистим}.",
    "{○○ починає кожен урок у робочому настрої завдяки добрій організованості|Ти починаєш кожен урок у робочому настрої завдяки добрій організованості}."
   ]
  },
  "punctual": {
   "kw": "пунктуальність",
   "lines": [
    "{○○ щодня приходить вчасно й з готовністю вчитися|Ти щодня приходиш вчасно й з готовністю вчитися}.",
    "{○○ вміло розпоряджається часом і дотримується термінів|Ти вміло розпоряджаєшся часом і дотримуєшся термінів}.",
    "{○○ завжди приходить на урок вчасно й з усім потрібним|Ти завжди приходиш на урок вчасно й з усім потрібним}.",
    "{○○ максимально використовує|Ти максимально використовуєш} кожен шкільний день завдяки пунктуальності.",
    "{○○ здає роботи в строк і розумно використовує час|Ти здаєш роботи в строк і розумно використовуєш час}.",
    "{○○ має|Ти маєш} міцну звичку приходити вчасно й мати все потрібне напоготові."
   ]
  },
  "rules": {
   "kw": "самодисципліна",
   "lines": [
    "{○○ дотримується розпорядку в класі й подає приклад іншим|Ти дотримуєшся розпорядку в класі й подаєш приклад іншим}.",
    "{○○ виявляє|Ти виявляєш} відмінну самодисципліну та повагу до правил класу.",
    "{○○ розуміє очікування класу й послідовно їх дотримується|Ти розумієш очікування класу й послідовно їх дотримуєшся}.",
    "{○○ поводиться спокійно й розважливо — це приклад для інших|Ти поводишся спокійно й розважливо — це приклад для інших}.",
    "{○○ робить|Ти робиш} правильний вибір, навіть коли поруч немає дорослих.",
    "{○○ допомагає та співпрацює, тож розпорядок класу діє злагоджено|Ти допомагаєш і співпрацюєш, тож розпорядок класу діє злагоджено}."
   ]
  },
  "independent": {
   "kw": "самостійність",
   "lines": [
    "{○○ самостійно виконує|Ти самостійно виконуєш} щоденні справи й розпорядок дня.",
    "{○○ дбає|Ти дбаєш} про власні речі та справи без сторонньої допомоги.",
    "{○○ доглядає за власними речами й без допомоги готується|Ти доглядаєш за власними речами й без допомоги готуєшся} до кожного уроку.",
    "{○○ вражає|Ти вражаєш} самостійністю у щоденних справах.",
    "{○○ впевнено справляється з щоденними завданнями й просить допомоги лише за потреби|Ти впевнено справляєшся з щоденними завданнями й просиш допомоги лише за потреби}.",
    "{○○ без труднощів збирається та переходить|Ти без труднощів збираєшся та переходиш} між видами діяльності."
   ]
  },
  "cleaning": {
   "kw": "сумлінне чергування в класі",
   "lines": [
    "{○○ серйозно ставиться до чергування й залишає|Ти серйозно ставишся до чергування й залишаєш} закріплену ділянку бездоганно чистою.",
    "{○○ старанно працює|Ти старанно працюєш} під час прибирання.",
    "{○○ наполегливо працює під час прибирання й помічає|Ти наполегливо працюєш під час прибирання й помічаєш} кожен куточок.",
    "{○○ завжди ретельно й без нарікань виконує|Ти завжди ретельно й без нарікань виконуєш} свої завдання з прибирання.",
    "{○○ пишається|Ти пишаєшся} чистотою й порядком у нашому класі.",
    "Під час прибирання {○○ надійно доводить|ти надійно доводиш} справу до кінця."
   ]
  },
  "cadre": {
   "kw": "надійне виконання обов'язків у класі",
   "lines": [
    "{○○ дбайливо й надійно виконує|Ти дбайливо й надійно виконуєш} обов'язки помічника в класі.",
    "На посаді класного помічника {○○ подає приклад і підтримує вчителя|ти подаєш приклад і підтримуєш вчителя}.",
    "{○○ зріло й дбайливо ставиться|Ти зріло й дбайливо ставишся} до обов'язків помічника в класі.",
    "{○○ надійно працює|Ти надійно працюєш} як помічник у класі — це велика підтримка для всіх.",
    "{○○ виконує доручення без нагадувань і подає|Ти виконуєш доручення без нагадувань і подаєш} чудовий приклад.",
    "У ролі помічника {○○ — надійна, організована й справедлива людина|ти — надійна, організована й справедлива людина}."
   ]
  },
  "service": {
   "kw": "готовність допомагати",
   "lines": [
    "{○○ охоче допомагає з дорученнями в класі й серйозно до них ставиться|Ти охоче допомагаєш з дорученнями в класі й серйозно до них ставишся}.",
    "{○○ завжди охоче підставляє плече|Ти завжди охоче підставляєш плече}, щоб у класі все йшло гладко.",
    "{○○ швидко зголошується|Ти швидко зголошуєшся}, коли потрібно щось зробити.",
    "Усі цінують, що {○○ охоче долучається до спільної справи|ти охоче долучаєшся до спільної справи}.",
    "{○○ пропонує допомогу з дорученнями в класі та дбайливо їх виконує|Ти пропонуєш допомогу з дорученнями в класі та дбайливо їх виконуєш}.",
    "Коли потрібна допомога, {○○ одним із перших виходить|ти одним із перших виходиш} уперед."
   ]
  },
  "sports": {
   "kw": "спортивні здібності",
   "lines": [
    "{○○ досягає відмінних результатів на фізкультурі й виявляє дух чесної гри|Ти досягаєш відмінних результатів на фізкультурі й виявляєш дух чесної гри}.",
    "{○○ вносить|Ти вносиш} енергію та командний дух у спортивні заняття.",
    "{○○ грає енергійно й вправно на фізкультурі та підбадьорює|Ти граєш енергійно й вправно на фізкультурі та підбадьорюєш} товаришів по команді.",
    "{○○ вирізняється|Ти вирізняєшся} координацією та фізичною підготовкою на рухливих заняттях.",
    "{○○ грає чесно, дотримується правил і завжди по-спортивному ставиться до гри|Ти граєш чесно, дотримуєшся правил і завжди по-спортивному ставишся до гри}.",
    "Фізкультура — очевидна сильна сторона, і {○○ докладає|ти докладаєш} повних зусиль у кожному виді діяльності."
   ]
  },
  "art": {
   "kw": "художній талант",
   "lines": [
    "{○○ має|Ти маєш} справжній хист до образотворчого мистецтва — роботи творчі й яскраві.",
    "{○○ вкладає|Ти вкладаєш} у роботи з мистецтва уяву та ретельність.",
    "{○○ вдумливо використовує|Ти вдумливо використовуєш} колір і деталі в малюнках.",
    "{○○ створює оригінальні роботи й акуратно доводить їх до кінця|Ти створюєш оригінальні роботи й акуратно доводиш їх до кінця}.",
    "{○○ підходить|Ти підходиш} до мистецтва з уявою та готовністю експериментувати.",
    "У кожній роботі, яку {○○ створює|ти створюєш}, сяє творчість."
   ]
  },
  "music": {
   "kw": "музичний талант",
   "lines": [
    "{○○ виявляє справжній талант до музики й бере|Ти виявляєш справжній талант до музики й береш} участь із захопленням.",
    "{○○ має гарний музичний слух і любить|Ти маєш гарний музичний слух і любиш} співати та грати.",
    "{○○ співає впевнено й тримає|Ти співаєш впевнено й тримаєш} рівний ритм.",
    "{○○ приносить|Ти приносиш} на наші уроки енергію своїм захопленням музикою.",
    "{○○ швидко засвоює|Ти швидко засвоюєш} нові пісні та ритми.",
    "Музика — очевидна пристрасть, і {○○ бере|ти береш} участь із щирою радістю."
   ]
  },
  "writing": {
   "kw": "сильні письмові навички",
   "lines": [
    "{○○ пише|Ти пишеш} чітко та з уявою.",
    "{○○ пише добре структуровані тексти з багатим словником|Ти пишеш добре структуровані тексти з багатим словником}.",
    "{○○ використовує|Ти використовуєш} цікаві слова та чітку структуру в письмових роботах.",
    "{○○ пише фантазійні історії, які приємно читати|Ти пишеш фантазійні історії, які приємно читати}.",
    "{○○ дедалі вправніше й детальніше висловлює|Ти дедалі вправніше й детальніше висловлюєш} думки на письмі.",
    "Письмо — справжня сильна сторона, і {○○ із задоволенням складає|ти із задоволенням складаєш} історії та пояснення."
   ]
  },
  "creative": {
   "kw": "творчість",
   "lines": [
    "{○○ вносить творчі ідеї в проєкти й любить|Ти вносиш творчі ідеї в проєкти й любиш} практичні заняття.",
    "{○○ мислить творчо й знаходить|Ти мислиш творчо й знаходиш} оригінальні розв'язання задач.",
    "{○○ пропонує оригінальні ідеї та любить|Ти пропонуєш оригінальні ідеї та любиш} конструювати й майструвати.",
    "{○○ приносить|Ти приносиш} у класні проєкти свіжі ідеї завдяки багатій уяві.",
    "{○○ любить експериментувати та знаходить|Ти любиш експериментувати та знаходиш} винахідливі способи розв'язувати задачі.",
    "У практичних проєктах {○○ розкриває творчість і винахідливість|ти розкриваєш творчість і винахідливість}."
   ]
  },
  "stage": {
   "kw": "чітке мовлення",
   "lines": [
    "{○○ говорить|Ти говориш} чітко та впевнено перед класом.",
    "{○○ виступає виразно та захоплює|Ти виступаєш виразно та захоплюєш} слухачів.",
    "{○○ виступає перед класом чітким голосом і підтримує|Ти виступаєш перед класом чітким голосом і підтримуєш} зоровий контакт.",
    "{○○ ретельно готує презентації, які захоплюють слухачів|Ти ретельно готуєш презентації, які захоплюють слухачів}.",
    "{○○ впевнено виступає перед аудиторією та чітко пояснює|Ти впевнено виступаєш перед аудиторією та чітко пояснюєш} ідеї.",
    "{○○ почувається природно|Ти почуваєшся природно}, виступаючи перед іншими."
   ]
  },
  "logic": {
   "kw": "логічне мислення",
   "lines": [
    "{○○ мислить логічно й розв'язує|Ти мислиш логічно й розв'язуєш} задачі кількома способами.",
    "{○○ любить складні задачі й чітко міркує|Ти любиш складні задачі й чітко міркуєш}.",
    "{○○ розбиває задачі на кроки й чітко пояснює хід міркувань|Ти розбиваєш задачі на кроки й чітко пояснюєш хід міркувань}.",
    "{○○ виявляє|Ти виявляєш} логічне мислення в головоломках і складних завданнях.",
    "{○○ швидко помічає закономірності й використовує|Ти швидко помічаєш закономірності й використовуєш} їх для пошуку розв'язків.",
    "{○○ добре міркує|Ти добре міркуєш} над хитрими запитаннями — це одна з сильних сторін."
   ]
  },
  "prog_study": {
   "kw": "помітний навчальний прогрес",
   "lines": [
    "{○○ демонструє|Ти демонструєш} чудовий навчальний прогрес цього семестру.",
    "Наполеглива праця окупилася: {○○ стабільно й помітно покращує результати|ти стабільно й помітно покращуєш результати}.",
    "{○○ стабільно покращує|Ти стабільно покращуєш} результати з усіх предметів протягом семестру.",
    "{○○ помітно зростає|Ти помітно зростаєш} у навчанні протягом останніх місяців.",
    "Успіхи, яких {○○ досягає|ти досягаєш} у класі цього семестру, очевидні.",
    "{○○ розвиває міцніші навички й тепер успішно береться|Ти розвиваєш міцніші навички й тепер успішно береш} за складніші завдання."
   ]
  },
  "prog_confidence": {
   "kw": "зростаюча впевненість",
   "lines": [
    "{○○ набуває впевненості й тепер охочіше ділиться|Ти набуваєш впевненості й тепер охочіше ділишся} ідеями.",
    "Чудово бачити, як {○○ набуває|ти набуваєш} дедалі більше впевненості протягом семестру.",
    "{○○ тепер охочіше бере|Ти тепер охочіше береш} участь у житті класу, ніж на початку семестру.",
    "Зростання віри в себе видно з того, як {○○ пробує|ти пробуєш} нове.",
    "{○○ охочіше висловлюється й ділиться|Ти охочіше висловлюєшся й ділишся} ідеями.",
    "{○○ виявляє|Ти виявляєш} нову впевненість у роботі та участі на уроках."
   ]
  },
  "prog_habit": {
   "kw": "кращі щоденні звички",
   "lines": [
    "{○○ робить|Ти робиш} великі кроки в дотриманні розпорядку та самостійному керуванні поведінкою.",
    "{○○ помітно покращує|Ти помітно покращуєш} зосередженість і робочі звички.",
    "{○○ тепер значно самостійніше дотримується|Ти тепер значно самостійніше дотримуєшся} щоденного розпорядку.",
    "{○○ значно покращує|Ти значно покращуєш} організованість і готовність до уроків.",
    "{○○ поводиться|Ти поводишся} на уроках спокійніше й зосередженіше.",
    "Завдяки кращим звичкам {○○ більше отримує|ти більше отримуєш} від кожного шкільного дня."
   ]
  },
  "prog_social": {
   "kw": "міцніша дружба",
   "lines": [
    "{○○ розвивається соціально й тепер добре ладнає|Ти розвиваєшся соціально й тепер добре ладнаєш} з однокласниками.",
    "{○○ вчиться|Ти вчишся} спокійно висловлювати почуття та добре працювати з іншими.",
    "{○○ тепер комфортніше працює|Ти тепер комфортніше працюєш} з однокласниками в парах і групах.",
    "{○○ почувається|Ти почуваєшся} дедалі невимушеніше з різними однокласниками протягом семестру.",
    "{○○ виявляє|Ти виявляєш} більше терпіння та розуміння до інших.",
    "Цього семестру {○○ набагато легше ладнає|ти набагато легше ладнаєш} з однокласниками."
   ]
  },
  "a_concept": {
   "kw": "міцне розуміння: {c}",
   "lines": [
    "{○○ демонструє|Ти демонструєш} міцне розуміння матеріалу в галузі «{subj}» (теми: {c}).",
    "У галузі «{subj}» {○○ швидко й точно засвоює|ти швидко й точно засвоюєш} нові ідеї.",
    "{○○ добре розуміє теми й може пояснити основні ідеї|Ти добре розумієш теми й можеш пояснити основні ідеї} (теми: {c}).",
    "{○○ міцно розуміє|Ти міцно розумієш} матеріал (теми: {c}), і це розуміння зростає.",
    "Коли в галузі «{subj}» з'являються нові ідеї, {○○ пов'язує їх із тим, що вже знає|ти пов'язуєш їх із тим, що вже знаєш}.",
    "{○○ чітко розуміє|Ти чітко розумієш} ключові ідеї в галузі «{subj}»."
   ]
  },
  "a_skill": {
   "kw": "упевнене володіння: {k}",
   "lines": [
    "{○○ виявляє|Ти виявляєш} дедалі кращі навички: {k}.",
    "{○○ має|Ти маєш} сильні й стабільні навички: {k}.",
    "{○○ набуває|Ти набуваєш} впевненості: {k}.",
    "Прогрес у класі помітний: {k}.",
    "{○○ докладає|Ти докладаєш} справжніх зусиль: {k}.",
    "{○○ дедалі легше справляється|Ти дедалі легше справляєшся} із завданнями: {k}."
   ]
  },
  "a_apply": {
   "kw": "застосування знань",
   "lines": [
    "{○○ легко застосовує|Ти легко застосовуєш} знання з галузі «{subj}» у нових ситуаціях.",
    "{○○ знаходить|Ти знаходиш} вдалі зв'язки між галуззю «{subj}» і повсякденним життям.",
    "{○○ використовує|Ти використовуєш} те, що вивчено в галузі «{subj}», для нових завдань.",
    "{○○ вміє|Ти вмієш} брати ідеї з галузі «{subj}» і використовувати їх по-новому.",
    "{○○ часто пов'язує|Ти часто пов'язуєш} вивчене в галузі «{subj}» з реальним життям.",
    "{○○ застосовує|Ти застосовуєш} нові навички з галузі «{subj}» на практиці."
   ]
  },
  "a_express": {
   "kw": "чіткі пояснення",
   "lines": [
    "{○○ чітко пояснює|Ти чітко пояснюєш} ідеї під час обговорень у галузі «{subj}».",
    "{○○ впевнено ділиться|Ти впевнено ділишся} ідеями на уроках у галузі «{subj}».",
    "{○○ чітко передає|Ти чітко передаєш} ідеї в галузі «{subj}» і усно, і письмово.",
    "На уроках у галузі «{subj}» {○○ ділиться думками і вислуховує погляди інших|ти ділишся думками і вислуховуєш погляди інших}.",
    "{○○ робить|Ти робиш} вдумливий і чіткий внесок в обговорення в галузі «{subj}».",
    "У галузі «{subj}» {○○ добирає|ти добираєш} точні слова, щоб висловити ідеї."
   ]
  },
  "a_explore": {
   "kw": "вдумливий пошук",
   "lines": [
    "{○○ ставить вдумливі запитання й досліджує|Ти ставиш вдумливі запитання й досліджуєш} ідеї в галузі «{subj}».",
    "{○○ пробує|Ти пробуєш} різні стратегії, розв'язуючи задачі.",
    "У галузі «{subj}» {○○ із задоволенням досліджує запитання і шукає|ти із задоволенням досліджуєш запитання і шукаєш} відповіді.",
    "{○○ виявляє|Ти виявляєш} цікавість у галузі «{subj}», що породжує вдумливі запитання.",
    "{○○ охоче перевіряє ідеї та вчиться|Ти охоче перевіряєш ідеї та вчишся} на результатах.",
    "У галузі «{subj}» {○○ ретельно міркує й розглядає|ти ретельно міркуєш і розглядаєш} запитання з різних боків."
   ]
  },
  "a_work": {
   "kw": "ретельне виконання: {w}",
   "lines": [
    "Виконано повністю й ретельно: {w}.",
    "{○○ ретельно доводить|Ти ретельно доводиш} до кінця: {w}.",
    "{○○ акуратно й вчасно виконує|Ти акуратно й вчасно виконуєш}: {w}.",
    "{○○ виявляє|Ти виявляєш} ретельність і увагу до деталей у роботі: {w}.",
    "{○○ прагне|Ти прагнеш} виконувати ґрунтовно й охайно: {w}.",
    "{○○ здає|Ти здаєш} повні й охайно оформлені роботи: {w}."
   ]
  },
  "a_engage": {
   "kw": "активна участь",
   "lines": [
    "{○○ активно та із захопленням працює|Ти активно та із захопленням працюєш} на уроках «{subj}».",
    "{○○ виявляє|Ти виявляєш} справжній інтерес до «{subj}».",
    "{○○ охоче бере|Ти охоче береш} участь у діяльності на уроках «{subj}».",
    "{○○ щиро захоплюється|Ти щиро захоплюєшся} предметом «{subj}», і це видно на кожному уроці.",
    "{○○ енергійно й позитивно долучається|Ти енергійно й позитивно долучаєшся} до уроків «{subj}».",
    "{○○ з нетерпінням чекає|Ти з нетерпінням чекаєш} на уроки «{subj}» і не втрачає зацікавленості до кінця."
   ]
  },
  "a_improve": {
   "kw": "стабільний прогрес",
   "lines": [
    "Цього семестру {○○ робить|ти робиш} стабільні успіхи в «{subj}».",
    "{○○ показує|Ти показуєш} дедалі кращі результати з «{subj}».",
    "{○○ стабільно розвиває|Ти стабільно розвиваєш} свої навички з «{subj}» упродовж семестру.",
    "{○○ помітно просувається|Ти помітно просуваєшся} в «{subj}» завдяки наполегливій праці.",
    "Протягом семестру {○○ почувається|ти почуваєшся} дедалі впевненіше в «{subj}».",
    "Щомісяця {○○ надбудовує|ти надбудовуєш} нові знання на раніше вивченому з «{subj}»."
   ]
  }
 },
 "wishes": {
  "w_focus": [
   "Далі {○○ може|ти можеш} вчитися зберігати зосередженість на уроках — тоді навчання даватиме ще більше задоволення.",
   "Я вірю, що {○○ зуміє|ти зумієш} утримувати увагу на уроці й відкласти все, що відволікає.",
   "Практикуючи активне слухання (наприклад, стежачи поглядом за мовцем), {○○ вловлюватиме|ти вловлюватимеш} усі ключові ідеї.",
   "Якщо тримати на парті лише потрібне приладдя, {○○ легше зосереджуватиметься|ти легше зосереджуватимешся}.",
   "Далі розвиваючи зосередженість під час самостійної роботи, {○○ виконуватиме|ти виконуватимеш} завдання впевнено."
  ],
  "w_careful": [
   "Якщо перевіряти роботу перед здачею, {○○ уникатиме|ти уникатимеш} дрібних помилок.",
   "Далі {○○ може|ти можеш} працювати повільніше й двічі перевіряти відповіді.",
   "Якщо двічі прочитувати кожне запитання перед відповіддю, {○○ помічатиме|ти помічатимеш} дрібні помилки.",
   "{○○ може|Ти можеш} користуватися коротким списком для перевірки перед здачею роботи.",
   "Якщо наприкінці кожного завдання переглядати відповіді, {○○ робитиме|ти робитимеш} свої роботи ще точнішими."
  ],
  "w_homework": [
   "Якщо встановити регулярний розпорядок виконання домашніх завдань, {○○ здаватиме|ти здаватимеш} їх вчасно.",
   "{○○ може щодня звіряти|Ти можеш щодня звіряти} список домашніх завдань, щоб нічого не пропустити.",
   "Папка для домашніх завдань, у якій вони переносяться між домом і школою, допоможе тримати все під контролем.",
   "Далі {○○ може|ти можеш} щодня починати домашнє завдання в один і той самий час.",
   "Якщо складати виконане домашнє завдання ввечері, воно вчасно потрапить до школи."
  ],
  "w_handwriting": [
   "Якщо писати повільніше, {○○ писатиме|ти писатимеш} охайніше й розбірливіше.",
   "Далі потрібно приділяти більше уваги почерку й оформленню роботи.",
   "Якщо щодня кілька хвилин вправлятися в написанні літер, {○○ писатиме|ти писатимеш} охайніше.",
   "{○○ може залишати|Ти можеш залишати} чіткі проміжки між словами та писати літери по лінійці.",
   "Якщо приділити оформленню трохи більше часу, {○○ яскравіше покаже|ти яскравіше покажеш} свої гарні ідеї."
  ],
  "w_speak": [
   "{○○ може частіше ділитися|Ти можеш частіше ділитися} ідеями в класі, адже {○○ має|ти маєш} цінні думки.",
   "Далі можна частіше піднімати руку й долучатися до обговорень у класі.",
   "Якщо спершу обговорити ідеї з напарником, {○○ легше ділитиметься|ти легше ділитимешся} ними з усім класом.",
   "{○○ може поставити|Ти можеш поставити} собі невелику мету: висловитися хоча б раз у кожному обговоренні.",
   "Коли {○○ частіше міркує|ти частіше міркуєш} вголос, {○○ допомагає|ти допомагаєш} також однокласникам вчитися."
  ],
  "w_emotion": [
   "Далі {○○ може|ти можеш} у хвилину засмучення зробити глибокий вдих, а потім розповісти словами про свої почуття.",
   "Практикуючи способи заспокоєння, {○○ краще долатиме|ти краще долатимеш} розчарування.",
   "Якщо називати почуття вголос, {○○ швидко отримає|ти швидко отримаєш} потрібну підтримку.",
   "{○○ може|Ти можеш} зробити коротку паузу й порахувати до п'яти, коли стає складно.",
   "Далі можна вчитися спокійно справлятися з розчаруванням, наприклад повільно дихаючи."
  ],
  "w_friends": [
   "{○○ може слухати|Ти можеш слухати} ідеї інших і вживати добрі слова, коли виникають розбіжності.",
   "Подальше тренування терпіння з однокласниками допоможе дружбі міцніти.",
   "{○○ може запрошувати|Ти можеш запрошувати} до спільної роботи й ігор різних однокласників.",
   "Якщо вправлятися чекати своєї черги й ділитися, {○○ ще міцніше дружитиме|ти ще міцніше дружитимеш} з однокласниками.",
   "Далі {○○ може|ти можеш} спокійно обговорювати розбіжності та шукати справедливе рішення."
  ],
  "w_tidy": [
   "Одна хвилина щодня на порядок на парті й у наплічнику — і {○○ працюватиме|ти працюватимеш} на уроках спокійніше й організованіше.",
   "Далі можна тримати приладдя в порядку й напоготові до уроку.",
   "Із простим списком наприкінці дня {○○ триматиме|ти триматимеш} приладдя в порядку.",
   "{○○ може повертати|Ти можеш повертати} кожну річ на місце одразу після використання.",
   "Далі можна розкладати папки так, щоб документи було легко знайти."
  ],
  "w_reading": [
   "Якщо щодня читати по десять хвилин, {○○ збагачуватиме словниковий запас і поглиблюватиме|ти збагачуватимеш словниковий запас і поглиблюватимеш} розуміння прочитаного.",
   "{○○ може читати|Ти можеш читати} вдома більше різних книжок.",
   "Читання вголос по кілька хвилин майже щодня допоможе розвинути плавність читання та впевненість.",
   "{○○ може спробувати|Ти можеш спробувати} книжки нових жанрів, наприклад науково-популярні або поезію.",
   "Якщо обговорювати кожну книжку після прочитання, {○○ глибше розумітиме|ти глибше розумітимеш} прочитане."
  ],
  "w_initiative": [
   "Далі {○○ може|ти можеш} одразу просити про допомогу, щойно щось незрозуміло.",
   "Якщо виявляти більше ініціативи в навчанні, {○○ вийде|ти вийдеш} на новий рівень.",
   "{○○ може ставити|Ти можеш ставити} запитання щоразу, коли виникає цікавість.",
   "Якщо самостійно робити перший крок до виконання завдань, {○○ зростатиме|ти зростатимеш} у навчанні.",
   "Далі можна шукати додаткове завдання підвищеної складності після виконання класної роботи."
  ],
  "w_rules": [
   "{○○ може й надалі дотримуватися|Ти можеш і надалі дотримуватися} правил класу, як-от говорити по черзі та терпляче чекати.",
   "Далі потрібно пам'ятати про домовленості класу протягом усього дня.",
   "Подальше дотримання домовленостей класу під час переходів між заняттями допоможе дню минати спокійно.",
   "{○○ може зупинятися|Ти можеш зупинятися} й думати, як вибір впливає на інших.",
   "Якщо вправлятися чекати своєї черги, щоб висловитися, {○○ виявлятиме|ти виявлятимеш} повагу до однокласників."
  ],
  "w_confidence": [
   "{○○ може сміливо братися|Ти можеш сміливо братися} за нові виклики, адже помилки — частина навчання.",
   "Далі {○○ може|ти можеш} трохи більше довіряти власним силам.",
   "Якщо щотижня братися за один новий виклик, {○○ набиратиметься|ти набиратимешся} впевненості.",
   "{○○ може радіти|Ти можеш радіти} маленьким успіхам і пам'ятати, що найважливіші — зусилля.",
   "Далі можна час від часу обирати складніший варіант, знаючи, що підтримка завжди поруч."
  ],
  "w_time": [
   "Із простим планером для домашніх завдань і повторення {○○ матиме|ти матимеш} менше поспіху.",
   "Далі можна вправлятися в плануванні часу та визначенні пріоритетів.",
   "Якщо ділити великі завдання на менші кроки, {○○ встигатиме|ти встигатимеш} за графіком.",
   "{○○ може починати|Ти можеш починати} довші завдання заздалегідь, а не в останню мить.",
   "Із таймером під час роботи {○○ легше триматиметься|ти легше триматимешся} плану."
  ]
 },
 "areas": {
  "chinese": {
   "subj": "мова та література",
   "c": "читання та словниковий запас",
   "k": "читання й письмо",
   "w": "письмові роботи"
  },
  "math": {
   "subj": "математика",
   "c": "поняття числа та геометрії",
   "k": "обчислення та розв'язування задач",
   "w": "практичні завдання"
  },
  "english": {
   "subj": "англійська мова",
   "c": "лексика та мовні конструкції",
   "k": "аудіювання та говоріння",
   "w": "домашні завдання з англійської"
  },
  "social": {
   "subj": "суспільствознавство",
   "c": "теми про громаду та історію",
   "k": "дослідження та презентації",
   "w": "проєктні роботи"
  },
  "science": {
   "subj": "природознавство",
   "c": "основні природничі поняття",
   "k": "спостереження та досліди",
   "w": "лабораторні роботи"
  },
  "arts": {
   "subj": "мистецтво",
   "c": "основи образотворчого мистецтва та музики",
   "k": "творчість і виконавство",
   "w": "творчі роботи"
  },
  "pe": {
   "subj": "здоров'я та фізична культура",
   "c": "здоровий спосіб життя",
   "k": "фізичні навички",
   "w": "роботи зі здоров'я та фізкультури"
  },
  "integrative": {
   "subj": "життєві навички",
   "c": "самопізнання та життєві навички",
   "k": "групові заняття",
   "w": "роботи із заходів"
  },
  "life": {
   "subj": "я досліджую світ",
   "c": "навколишній світ",
   "k": "спостереження та створення",
   "w": "проєктні роботи"
  }
 },
 "frames": {
  "openings": [
   {
    "t": "○○ — справжня радість для нашого класу цього семестру.",
    "u": [
     "term"
    ],
    "p": "parent",
    "tone": "warm"
   },
   {
    "t": "○○ має чудовий семестр.",
    "u": [
     "term"
    ],
    "p": "parent",
    "tone": "warm"
   },
   {
    "t": "Який чудовий семестр: ○○ справді розквітає!",
    "u": [
     "term"
    ],
    "p": "parent",
    "tone": "warm"
   },
   {
    "t": "Було великою радістю мати тебе в нашому класі цього семестру.",
    "u": [
     "term"
    ],
    "p": "child",
    "tone": "warm"
   },
   {
    "t": "○○, у тебе чудовий семестр!",
    "u": [
     "term"
    ],
    "p": "child",
    "tone": "warm"
   },
   {
    "t": "○○ має успішний семестр.",
    "u": [
     "term"
    ],
    "p": "parent",
    "tone": "formal"
   },
   {
    "t": "{○○ демонструє|Ти демонструєш} стабільне зростання цього семестру.",
    "u": [
     "term"
    ],
    "tone": "formal"
   },
   {
    "t": "{○○ виявляє|Ти виявляєш} дедалі більшу зрілість цього семестру.",
    "u": [
     "term"
    ],
    "g": [
     "high"
    ]
   },
   {
    "t": "Останнім часом {○○ добре працює|ти добре працюєш} у класі.",
    "u": [
     "brief"
    ]
   },
   {
    "t": "Хочу поділитися гарною новиною: ○○ тішить нас успіхами.",
    "u": [
     "brief",
     "cheer"
    ],
    "p": "parent",
    "tone": "warm"
   },
   {
    "t": "Чудова робота сьогодні, ○○!",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "○○, сьогодні мені впало в око щось чудове!",
    "u": [
     "cheer"
    ],
    "p": "child",
    "tone": "warm"
   },
   {
    "t": "{○○ досягає|Ти досягаєш} вражаючого прогресу цього семестру.",
    "u": [
     "special"
    ],
    "f": "progress"
   },
   {
    "t": "Скільки змін за цей семестр: {○○ помітно зростає|ти помітно зростаєш}!",
    "u": [
     "special"
    ],
    "f": "progress",
    "tone": "warm"
   },
   {
    "t": "Кожна дитина вчиться у власному темпі, і ○○ зростає стабільно.",
    "u": [
     "special"
    ],
    "f": "support",
    "p": "parent"
   },
   {
    "t": "Кожен вчиться у власному темпі, а ти зростаєш стабільно.",
    "u": [
     "special"
    ],
    "f": "support",
    "p": "child"
   },
   {
    "t": "{○○ має|Ти маєш} насичений і плідний семестр.",
    "u": [
     "term"
    ]
   },
   {
    "t": "Цей семестр — час справжнього зростання: {○○ розвивається|ти розвиваєшся}.",
    "u": [
     "term"
    ]
   },
   {
    "t": "{○○ приносить|Ти приносиш} мені справжнє задоволення на уроках цього семестру.",
    "u": [
     "term"
    ],
    "tone": "warm"
   },
   {
    "t": "Цього семестру мені було цікаво знайомитися ближче: {○○ — цікава особистість|ти — цікава особистість}.",
    "u": [
     "term"
    ],
    "tone": "warm"
   },
   {
    "t": "{○○ виконує|Ти виконуєш} завдання цього семестру дедалі самостійніше.",
    "u": [
     "term"
    ],
    "g": [
     "high"
    ]
   },
   {
    "t": "У цьому звіті підсумовано прогрес і сильні сторони за семестр: {○○ розвивається|ти розвиваєшся} стабільно.",
    "u": [
     "term"
    ],
    "tone": "formal"
   },
   {
    "t": "Коротко про те, як {○○ справляється|ти справляєшся}.",
    "u": [
     "brief"
    ]
   },
   {
    "t": "{○○ має|Ти маєш} вдалі кілька тижнів у класі.",
    "u": [
     "brief"
    ]
   },
   {
    "t": "У класі все йде добре: {○○ добре справляється|ти добре справляєшся}.",
    "u": [
     "brief"
    ],
    "tone": "warm"
   },
   {
    "t": "Маю сказати кілька добрих слів: ○○ на це заслуговує.",
    "u": [
     "cheer"
    ],
    "p": "parent"
   },
   {
    "t": "Ось маленька записка, щоб відзначити успіхи: ○○ на це заслуговує.",
    "u": [
     "cheer"
    ],
    "p": "parent",
    "tone": "warm"
   },
   {
    "t": "○○ заслуговує на добре слово.",
    "u": [
     "cheer"
    ],
    "p": "parent"
   },
   {
    "t": "○○, ось записка тільки для тебе.",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "○○, ти маєш чим пишатися.",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "Молодець, ○○!",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "Цього семестру {○○ помітно зростає|ти помітно зростаєш}.",
    "u": [
     "special"
    ],
    "f": "progress"
   },
   {
    "t": "{○○ має семестр справжніх успіхів|Ти маєш семестр справжніх успіхів}.",
    "u": [
     "special"
    ],
    "f": "progress"
   },
   {
    "t": "Цього семестру {○○ робить|ти робиш} важливі кроки вперед.",
    "u": [
     "special"
    ],
    "f": "progress"
   },
   {
    "t": "{○○ просувається|Ти просуваєшся} вперед у комфортному темпі, крок за кроком.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "Навчання потребує часу, і {○○ упевнено розвиває|ти упевнено розвиваєш} свої навички.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "Мені приємно розповісти, що {○○ чудово справляється|ти чудово справляєшся} цього семестру.",
    "u": [
     "special"
    ],
    "f": "support",
    "tone": "warm"
   }
  ],
  "fillers": [
   {
    "t": "Приємно спостерігати, як {○○ зростає|ти зростаєш} протягом цих місяців.",
    "u": [
     "term",
     "special"
    ],
    "tone": "warm"
   },
   {
    "t": "Завдяки цим якостям {○○ має|ти маєш} особливе місце в нашому класі.",
    "u": [
     "term",
     "brief"
    ]
   },
   {
    "t": "Дякую за вашу підтримку вдома.",
    "u": [
     "term",
     "brief",
     "special"
    ],
    "p": "parent"
   },
   {
    "t": "Загалом, {○○ навчається|ти навчаєшся} цього семестру стабільно.",
    "u": [
     "term"
    ],
    "tone": "formal"
   },
   {
    "t": "Цей прогрес є результатом щоденних наполегливих зусиль.",
    "u": [
     "special"
    ],
    "f": "progress"
   },
   {
    "t": "Не маю сумнівів, що завдяки подальшій практиці {○○ побачить|ти побачиш} результати.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "У школі {○○ й надалі матиме|ти й надалі матимеш} мою підтримку.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "{○○ працює|Ти працюєш} цього семестру стабільно.",
    "u": [
     "subject"
    ]
   },
   {
    "t": "Загальний прогрес у цій галузі хороший.",
    "u": [
     "subject"
    ],
    "tone": "formal"
   },
   {
    "t": "{○○ добре працює|Ти добре працюєш} на уроках у галузі «{subj}» і {виконує|виконуєш} завдання в класі.",
    "u": [
     "subject"
    ]
   },
   {
    "t": "{○○ поступово набуває|Ти поступово набуваєш} стійких навичок у галузі «{subj}».",
    "u": [
     "subject"
    ]
   },
   {
    "t": "Твої зусилля не залишаються непоміченими.",
    "u": [
     "cheer",
     "brief"
    ],
    "p": "child"
   },
   {
    "t": "{○○ добре звикає|Ти добре звикаєш} до розпорядку нашого класу й {починає|починаєш} кожен день із доброго настрою.",
    "u": [
     "term",
     "special"
    ]
   },
   {
    "t": "{○○ робить|Ти робиш} цього семестру великий внесок у життя нашого класу.",
    "u": [
     "term"
    ]
   },
   {
    "t": "Приємно бачити, як протягом семестру {○○ розкриває|ти розкриваєш} свої сильні сторони.",
    "u": [
     "term",
     "special"
    ],
    "tone": "warm"
   },
   {
    "t": "Протягом семестру {○○ відповідає|ти відповідаєш} очікуванням завдяки стабільним і позитивним зусиллям.",
    "u": [
     "term",
     "special"
    ],
    "tone": "formal"
   },
   {
    "t": "{○○ продовжує|Ти продовжуєш} зростати і як учень, і як частина класу.",
    "u": [
     "term",
     "special",
     "brief"
    ]
   },
   {
    "t": "{○○ приходить|Ти приходиш} до школи щодня з готовністю працювати.",
    "u": [
     "term",
     "special",
     "brief"
    ]
   },
   {
    "t": "{○○ стає|Ти стаєш} стабільною та надійною опорою нашого класу.",
    "u": [
     "term",
     "brief"
    ]
   },
   {
    "t": "Зусилля, які {○○ докладає|ти докладаєш} щодня, добре помітні.",
    "u": [
     "term",
     "special",
     "brief"
    ]
   },
   {
    "t": "{○○ має|Ти маєш} добрі стосунки і з однокласниками, і з учителями.",
    "u": [
     "term",
     "special"
    ]
   },
   {
    "t": "Видно, що {○○ дбає|ти дбаєш} про успіхи в школі.",
    "u": [
     "term",
     "special"
    ]
   },
   {
    "t": "Протягом семестру {○○ дедалі самостійніше діє|ти дедалі самостійніше дієш}.",
    "u": [
     "term",
     "special"
    ]
   },
   {
    "t": "Завдяки позитивному підходу {○○ допомагає|ти допомагаєш} всьому класу добре вчитися.",
    "u": [
     "term",
     "brief"
    ]
   },
   {
    "t": "Мені приємно бачити, як тиждень за тижнем {○○ дедалі впевненіше почувається|ти дедалі впевненіше почуваєшся}.",
    "u": [
     "term",
     "special"
    ],
    "tone": "warm"
   },
   {
    "t": "{○○ ставиться|Ти ставишся} до навчання стабільно й позитивно.",
    "u": [
     "term",
     "special"
    ],
    "tone": "formal"
   },
   {
    "t": "Невеликі, але стабільні кроки складаються у справжній прогрес: {○○ рухається|ти рухаєшся} вперед.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "Кожен тиждень дає нові можливості для практики, і {○○ добре користується|ти добре користуєшся} ними.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "Покращення цього семестру показує, на що здатні постійні зусилля.",
    "u": [
     "special"
    ],
    "f": "progress"
   },
   {
    "t": "{○○ уважно виконує|Ти уважно виконуєш} вказівки на уроках у галузі «{subj}» і {працює|працюєш} старанно.",
    "u": [
     "subject"
    ]
   },
   {
    "t": "{○○ виробляє|Ти виробляєш} добрі навчальні звички в галузі «{subj}».",
    "u": [
     "subject"
    ]
   },
   {
    "t": "Цього семестру {○○ працює|ти працюєш} у галузі «{subj}» стабільно й старанно.",
    "u": [
     "subject"
    ]
   },
   {
    "t": "Загалом, зусилля в галузі «{subj}» були стабільними.",
    "u": [
     "subject"
    ],
    "tone": "formal"
   },
   {
    "t": "Кожен твій маленький крок справді має значення.",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "Твоя наполеглива праця справді змінює ситуацію на краще.",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "Зусилля, які докладає ○○, не залишаються непоміченими.",
    "u": [
     "cheer",
     "brief"
    ],
    "p": "parent"
   }
  ],
  "closings": [
   {
    "t": "Так тримати!",
    "u": [
     "term",
     "brief",
     "cheer",
     "special"
    ],
    "tone": "warm"
   },
   {
    "t": "Продовжуй у тому ж дусі.",
    "u": [
     "term",
     "brief",
     "subject",
     "special"
    ],
    "tone": "formal"
   },
   {
    "t": "З нетерпінням чекаю, як {○○ й надалі сяятиме|ти й надалі сяятимеш} наступного семестру.",
    "u": [
     "term"
    ],
    "tone": "warm"
   },
   {
    "t": "Не маю сумнівів, що {○○ матиме|ти матимеш} ще сильніший семестр попереду.",
    "u": [
     "term",
     "special"
    ]
   },
   {
    "t": "Бажаю успіхів на наступному етапі — {○○ на них заслуговує|ти на них заслуговуєш}.",
    "u": [
     "term"
    ],
    "g": [
     "high"
    ]
   },
   {
    "t": "Так тримати!",
    "u": [
     "brief",
     "cheer",
     "subject"
    ]
   },
   {
    "t": "Я пишаюся тобою!",
    "u": [
     "cheer",
     "special"
    ],
    "p": "child",
    "tone": "warm"
   },
   {
    "t": "Світи й далі!",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "Разом ми й надалі працюватимемо над цими цілями.",
    "u": [
     "special"
    ],
    "f": "support"
   },
   {
    "t": "Чудово попрацювали цього семестру.",
    "u": [
     "subject",
     "term"
    ],
    "tone": "formal"
   },
   {
    "t": "З нетерпінням чекаю на все, чого {○○ досягне|ти досягнеш} наступного семестру.",
    "u": [
     "term"
    ]
   },
   {
    "t": "Попереду ще один чудовий семестр!",
    "u": [
     "term"
    ],
    "tone": "warm"
   },
   {
    "t": "Бажаю гарного відпочинку й сильного старту наступного семестру — {○○ на це заслуговує|ти на це заслуговуєш}.",
    "u": [
     "term"
    ]
   },
   {
    "t": "{○○ має|Ти маєш} пишатися досягненнями цього семестру.",
    "u": [
     "term"
    ]
   },
   {
    "t": "Цього семестру ○○ — частина нашого класу, і це справжня честь для мене.",
    "u": [
     "term"
    ],
    "p": "parent"
   },
   {
    "t": "Дякую за всю твою наполегливу працю цього семестру.",
    "u": [
     "term"
    ],
    "p": "child"
   },
   {
    "t": "Я й надалі повідомлятиму вас про успіхи дитини.",
    "u": [
     "brief"
    ],
    "p": "parent"
   },
   {
    "t": "Відбуваються чудові речі, тож продовжуй!",
    "u": [
     "brief",
     "cheer"
    ],
    "tone": "warm"
   },
   {
    "t": "З такою стабільною працею {○○ зайде|ти зайдеш} далеко.",
    "u": [
     "brief",
     "cheer",
     "special"
    ]
   },
   {
    "t": "{○○ рухається|Ти рухаєшся} у правильному напрямі.",
    "u": [
     "brief",
     "subject",
     "special"
    ]
   },
   {
    "t": "З нетерпінням чекаю подальших успіхів у галузі «{subj}».",
    "u": [
     "subject"
    ]
   },
   {
    "t": "Подальша практика закріпить ці сильні сторони.",
    "u": [
     "subject",
     "special"
    ]
   },
   {
    "t": "Чудово, і продовжуй у тому ж дусі.",
    "u": [
     "cheer",
     "brief"
    ]
   },
   {
    "t": "Ти впораєшся!",
    "u": [
     "cheer"
    ],
    "p": "child"
   },
   {
    "t": "Кожен крок уперед має значення, і попереду їх ще багато.",
    "u": [
     "special"
    ],
    "f": "support"
   }
  ]
 },
 "elaborations": {
  "area": [
   "Це свідчить про міцну основу в галузі «{subj}».",
   "Прогрес у галузі «{subj}» надихає.",
   "Загалом, робота в галузі «{subj}» хороша.",
   "Якість роботи в галузі «{subj}» свідчить про справжню старанність.",
   "Це міцна база для наступного етапу навчання в галузі «{subj}».",
   "{○○ має|Ти маєш} добру підготовку до наступних кроків у галузі «{subj}».",
   "Приємно бачити такий розвиток у галузі «{subj}»."
  ],
  "learning": [
   "Завдяки такому підходу до навчання {○○ має|ти маєш} міцну основу в усіх предметах.",
   "Завдяки цим звичкам {○○ упевнено дивиться|ти упевнено дивишся} у майбутнє.",
   "Завдяки цьому {○○ стабільно працює|ти стабільно працюєш} на сильному рівні.",
   "{○○ виробляє|Ти виробляєш} звички, які ведуть до довготривалого успіху.",
   "Такий стабільний підхід видно в якості щоденної роботи.",
   "Мені до душі позитивний настрій, з яким {○○ навчається|ти навчаєшся}.",
   "Завдяки цим сильним сторонам {○○ отримує|ти отримуєш} максимум від кожного уроку."
  ],
  "character": [
   "Ці якості важливіші навіть за оцінки.",
   "{○○ заслужує|Ти заслуговуєш} на повагу і однокласників, і вчителів.",
   "Приємно щодня бачити такий хороший характер.",
   "Однокласники знають, що {○○ завжди допоможе|ти завжди допоможеш}.",
   "{○○ подає|Ти подаєш} приклад тихо, але вагомо.",
   "Такий характер допомагає створювати в класі атмосферу турботи.",
   "Завдяки таким якостям {○○ добре впорається|ти добре впораєшся} і далеко за межами школи."
  ],
  "social": [
   "Однокласникам приємно вчитися й гратися поруч, коли {○○ в класі|ти в класі}.",
   "{○○ допомагає|Ти допомагаєш} робити наш клас теплим і привітним.",
   "Ці соціальні навички — справжній дар.",
   "Групова робота йде легше, коли в команді {○○|ти}.",
   "Ці навички допомагають кожному в класі почуватися частиною колективу.",
   "Уміння добре співпрацювати з іншими — одна з найцінніших навичок.",
   "{○○ допомагає|Ти допомагаєш} людям поруч розкритися якнайкраще."
  ],
  "routine": [
   "Ці добрі звички роблять навчання ефективнішим.",
   "{○○ подає|Ти подаєш} позитивний приклад іншим.",
   "Уміння добре справлятися зі щоденними справами — важливий крок дорослішання.",
   "Бути готовим і зібраним — значить мати більше часу на навчання.",
   "Завдяки цим звичкам {○○ спокійно й стабільно починає|ти спокійно й стабільно починаєш} кожен день.",
   "Такі добрі звички формують справжню самостійність.",
   "{○○ показує|Ти показуєш}, що маленькі щоденні звички дають великий результат."
  ],
  "service": [
   "Така готовність служити робить наш клас кращим.",
   "Завдяки цій допомозі розпорядок у класі працює злагодженіше.",
   "Присвячувати час допомозі іншим — є чим пишатися.",
   "Така допомога свідчить про справжню зрілість.",
   "{○○ виконує|Ти виконуєш} ці доручення з радістю, і це дуже цінується.",
   "Наш клас стає міцнішим завдяки такій допомозі.",
   "Це почуття служіння — якість, яку варто цінувати."
  ],
  "talent": [
   "Сподіваюся, {○○ й далі розвиватиме|ти й далі розвиватимеш} цей талант.",
   "Цей талант так багато додає нашим заходам у класі.",
   "Хвилююче бачити, як цей талант розвивається.",
   "Чудово бачити, як {○○ ділиться|ти ділишся} цим даром із класом.",
   "{○○ має|Ти маєш} усі підстави пишатися цим талантом.",
   "З подальшою практикою цей талант і далі зростатиме.",
   "Завдяки цій сильній стороні {○○ має|ти маєш} змогу засяяти особливим чином."
  ],
  "progress": [
   "Цей прогрес дався нелегко, і він заслуговує на визнання.",
   "Видно, що {○○ дуже старанно працює|ти дуже старанно працюєш}.",
   "Мені щиро приємно бачити цю зміну.",
   "Цей розвиток показує, чого можна досягти стабільними зусиллями.",
   "Шлях, який долає {○○|ти}, уже чималий, і це варто відзначити.",
   "Кожен маленький крок склався у справжню зміну.",
   "Цей прогрес — чудова основа для наступних місяців."
  ]
 },
 "compact": [
  {
   "t": "{○○ демонструє|Ти демонструєш} багато сильних сторін, зокрема: {L}."
  },
  {
   "t": "Серед особливих досягнень: {L}."
  },
  {
   "t": "{Сильні сторони дитини:|Твої сильні сторони:} {L}."
  },
  {
   "t": "{○○ вирізняється|Ти вирізняєшся} такими якостями: {L}."
  },
  {
   "t": "{Серед сильних сторін дитини:|Серед твоїх сильних сторін:} {L}."
  },
  {
   "t": "Ключові сильні сторони цього семестру: {L}.",
   "tone": "formal"
  },
  {
   "t": "Протягом семестру було приємно бачити таке: {L}.",
   "tone": "warm",
   "u": [
    "term",
    "brief",
    "special"
   ]
  },
  {
   "t": "Із задоволенням відзначаю таке: {L}.",
   "tone": "formal"
  }
 ],
 "connectors": [
  "Крім того, ",
  "Також ",
  "Окрім цього, "
 ],
 "wishLeads": [
  "",
  "",
  "Надалі, "
 ],
 "you": "ти",
 "possessive": "твій",
 "blankName": "[Ім'я]",
 "and": "і",
 "unit": "слів"
}
